import React from 'react';
import { User, LogOut } from 'lucide-react';

const Header = ({ stats, currentUser, onLogout }) => {
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="logo-section">
          <img 
            src="/centurion-logo.svg" 
            alt="Centurion Boats" 
            className="centurion-logo"
          />
        </div>
        
        {/* User info and logout button */}
        {currentUser && (
          <div className="user-section">
            <div className="user-info">
              <User size={16} />
              <span className="username">Welcome, {currentUser}</span>
            </div>
            <button 
              className="logout-button"
              onClick={onLogout}
              title="Logout"
            >
              <LogOut size={16} />
              <span>Logout</span>
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;